<template>
  <!--日电服务协议界面内容 -->
  <div style="width:100%;height:calc(100vh - 50px);overflow: hidden;" ref="otherfragment">
    <div>
      <hint></hint>
      <question-list :Datalist="datalist" @scrollto="ScrollTo" :scroll="scroll"></question-list>
      <div class="otherstruction_style" id='otherstruction' v-html="otherstruction">
        <!-- :style="{height:screenHeight+'px'}"-->
      </div>
      <div class="otherstruction_style">
        <table v-if="tableContent.length > 0">
          <tr v-for="(item, index) in tableContent" :key="index">
            <td v-for="(item2, key) in item" :key="key" style="white-space: pre-line;">
              <p :class="key === 'other' && item2 !== '特殊说明' ? 'p-left' : 'p-center'">{{ item2 }}</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import hint from './hint.vue'
  import QuestionList from './questionList.vue'
  import {otherinstruction} from '../struction/otherinstruction'
  import BScroll from '@better-scroll/core'
  export default {
    name: "Other",
    data() {
      return {
				screenHeight:500,
        datalist:[
          {des:'·保修范围要求',ref:'otherinstruction',href:'#otherinstruction'},
          {des:'·保修年限及说明',ref:'otherdeadline',href:'#otherdeadline'}
        ],
        otherstruction:otherinstruction.otherContent,
        tableContent: [
          {category:'品类',date1:'整机免费保修年限',date2:'易损件保修年限',name:'易损件名称',other:'特殊说明'},
          {category:'电热水器',date1:'8年',date2:'1',name:'遥控器、镁棒、泄压软管、旋钮、花洒',other:'1、易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换，其中镁棒需专业服务人员有偿上门更换，收取上门服务费，镁棒免费更换;\n2、内胆漏水，自购买之日起 8 年内免费换机。'},
          {category:'小厨宝',date1:'3年',date2:'1',name:'镁棒、泄压软管、旋钮',other:'1、易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换，其中镁棒需专业服务人员有偿上门更换，收取上门服务费，镁棒免费更换;\n2、内胆漏水，自购买之日起 5 年内免费换机。'},
          {category:'燃气热水器',date1:'零冷水、冷凝、变频系列保修5年',date2:'/',name:'/',other:'/'},
          {category:'燃气热水器',date1:'恒温、机械强排系列保修3年',date2:'1',name:'花洒、泄压、软管、旋钮',other:'易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换。'},
          {category:'烟机',date1:'5年',date2:'1',name:'油杯、冷光灯、滤网、烟管、玻璃制件',other:'1、易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换，其中冷光灯、玻璃制件需专业服务人员有偿上门更换，收取上门服务费，冷光灯、玻璃制件免费更换；\n2、电机终身保修3、用于商用整机保修半年。'},
          {category:'灶具',date1:'3年',date2:'1',name:'旋钮、火盖、锅支架、装饰环、玻璃制件',other:'1、嵌入式人工煤气灶整机保修 1年；\n2、易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换，其中玻璃制件需专业服务人员有偿上门更换，收取上门服务费，玻璃制件免费更换;\n3、用于商用整机保修半年。'},
          {category:'净水机',date1:'3年',date2:'1',name:'水龙头、PE管、玻璃制件',other:'1、易损件保修期内不上门更换，用户凭购买凭证和完整的易损件到当地维修网点免费更换，其中玻璃制件需专业服务人员有偿上门更换，收取上门服务费，玻璃制件免费更换;\n2、自购买之日起泵保修 5 年；\n3、滤芯属于耗材不在保修期内；\n4、用于商用整机保修1年。'},
          {category:'嵌入式（消毒柜/蒸烤箱）',date1:'3年',date2:'1',name:'紫外线管、石英发热管、玻璃制件',other:'易损件保修期内需专业服务人员有偿上门更换，收取上门服务费，凭购买凭证免费更换。'},
        ],
      scroll: '',
    }
  },
  props: {
    active: {
      type: String,
      default: '',
    }
  },
  mounted() {
    this.screenHeight = (window.innerHeight-320)+"px";
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.otherfragment, {
        click: true,
        scrollY: true,
        bounce: true,
      });
    });
  },
  methods: {
    ScrollTo: function (ref) {
      // var updistance = document.getElementById("otherstruction").offsetTop;
      // var distance = document.getElementById(ref).offsetTop;
      // var scrolldis = document.getElementById('otherstruction').scrollTop=distance - updistance-10;
    },
  },
  components: {
    'hint': hint,
    'question-list': QuestionList
  },
  watch: {
    active(newValue, oldValue) {
      if(newValue === "other_container"){
        this.scroll.refresh();
      }
    }
  }
}
</script>

<style scoped>
.otherstruction_style {
  width: 92%;
/* 	height: 400px;
 */	/* height: calc(100% - 30px); */
  text-align: left;
  padding-left: 4%;
  line-height: 120%;
  overflow-y: scroll;
  background: #FAFAFA;
}

table,
table,
 td {
    font-size: 12px;
     border: 1px solid #ccc;
     color:#333333;
 }

 table {
     margin: 0 auto;
     border-collapse: collapse;
     width: 100%;
     margin-bottom: 40px;
 }

 td {
     text-align: center;
     padding: 5px;
     min-width: 20px;
 }

 p{
    font-size:18px;
    color:#333333;
    margin-top:10px;
 }

 p.title {
     font-size: 18px;
     color: #333;
     margin: 15px 0;
 }

 .p-left{
  font-size: 12px;
  text-align: left; 
  width: 100%;
 }
 .p-center{
  font-size: 12px;
  width: 100%;
 }

 .table-container {
  margin-bottom: 40px;
  width: 92%;
  display: inline-block;
  /* padding-left: 4%; */
  line-height: 120%;
  /* overflow-y: scroll; */
  background: #FAFAFA;
 }


</style>



// WEBPACK FOOTER //
// src/components/Other.vue